import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class ThirdPartyClientService {
  static getClientsByCompany(companyId) {
    const url = API_ROUTES.THIRD_PARTY_CLIENT.GET_BY_COMPANY.replace("<companyId>", companyId);
    return HttpUtil.get(url);
  }

  static getClient(clientId) {
    const url = API_ROUTES.THIRD_PARTY_CLIENT.GET.replace("<clientId>", clientId);
    return HttpUtil.get(url);
  }

  static createClient(payload) {
    return HttpUtil.post(API_ROUTES.THIRD_PARTY_CLIENT.CREATE, payload);
  }

  static updateClient(clientId, payload) {
    const url = API_ROUTES.THIRD_PARTY_CLIENT.UPDATE.replace("<clientId>", clientId);
    return HttpUtil.put(url, payload);
  }

  static deleteClient(clientId) {
    const url = API_ROUTES.THIRD_PARTY_CLIENT.DELETE.replace("<clientId>", clientId);
    return HttpUtil.delete(url);
  }
}
